/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GoalDetailsCurrentReview_goal = {
    readonly currentReviewAt: string;
    readonly " $refType": "GoalDetailsCurrentReview_goal";
};
export type GoalDetailsCurrentReview_goal$data = GoalDetailsCurrentReview_goal;
export type GoalDetailsCurrentReview_goal$key = {
    readonly " $data"?: GoalDetailsCurrentReview_goal$data;
    readonly " $fragmentRefs": FragmentRefs<"GoalDetailsCurrentReview_goal">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GoalDetailsCurrentReview_goal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentReviewAt",
      "storageKey": null
    }
  ],
  "type": "Goal",
  "abstractKey": null
};
(node as any).hash = '9daee5157b144d61ab9c336ee3bc1e62';
export default node;
